import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['elementToShow']

  show(event) {
    this.elementToShowTarget.classList.remove('is-hidden');
  }
}